import React from "react";
import { FiArrowLeft } from "react-icons/fi";

import {
  Container,
  Content,
  Aside,
  BackButton,
  Wrapper,
  Logo,
  Info,
} from "./styles";
import Header from "../../components/Header";
import SignUpForm from "../../components/Signup";

function SignUp() {
  return (
    <Container>
      <Header />
      <Content>
        <Aside>
          <BackButton
            onClick={() => window.open("http://topusperformance.com.br/")}>
            <FiArrowLeft size={20} />
            Voltar pro site
          </BackButton>
          <Wrapper>
            <Logo />
            <Info>
              <p>
                Cadastre-se e receba um guia completo com um passo a passo de
                como transformar seu estilo de vida adquirindo hábitos
                saudáveis. E você ainda ganha:
              </p>
              <p>
                Acesso a <span>GRUPO</span> exclusivo no Telegram;
                <br />
                Treinos <span>AO VIVO</span> online;
                <br />
                Vídeo aulas com a Prof. Livia Mietherhofer;
                <br />
                <span>RECEITAS</span> exclusivas com passo a passo;
                <br />
                Um <span>PLANNER</span> exclusivo.
              </p>
            </Info>
          </Wrapper>
        </Aside>
        <SignUpForm />
      </Content>
    </Container>
  );
}

export default SignUp;
